import { supabase } from "../supabase/client";

export const taskService = {
    async getTasks(userId) {
        const { data, error } = await supabase
            .from("tasks")
            .select()
            .eq("user_id", userId)
            .order("created_at", { ascending: false });

        if (error) throw error;
        return data || [];
    },

    async createTask(taskPayload, userId) {
        const newTask = {
            name: taskPayload.name,
            description: taskPayload.description,
            project_id: taskPayload.project_id,
            priority: taskPayload.priority,
            due_date: taskPayload.due_date,
            due_time: taskPayload.due_time,
            is_recurring: taskPayload.is_recurring,
            recurrence_type: taskPayload.recurrence_type,
            recurrence_days: taskPayload.recurrence_days,
            reminder_type: taskPayload.reminder_type,
            reminder_date: taskPayload.reminder_date,
            done: false,
            user_id: userId
        };

        const { data, error } = await supabase
            .from("tasks")
            .insert([newTask])
            .select();

        if (error) throw error;
        return data || [];
    },

    async updateTask(id, updateFields, userId) {
        const { data, error } = await supabase
            .from("tasks")
            .update(updateFields)
            .eq("user_id", userId)
            .eq("id", id)
            .select();

        if (error) throw error;
        return data && data.length > 0 ? data[0] : null;
    },

    async deleteTask(id, userId) {
        const { error } = await supabase
            .from("tasks")
            .delete()
            .eq("user_id", userId)
            .eq("id", id);

        if (error) throw error;
    },

    async deleteMultipleTasks(taskIds, userId) {
        if (!taskIds || taskIds.length === 0) return;
        const { error } = await supabase
            .from("tasks")
            .delete()
            .eq("user_id", userId)
            .in("id", taskIds);

        if (error) throw error;
    }
};
